import { useEffect, useState } from 'react';
import axios from 'axios';
import { optionsCouleursParFamille } from '../../components/ndoe';
import config from '../../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

const EMPTY = { marques: [], categories: [], couleurs: [], matieres: [], pointures: [] };

/**
 * Listes de référence des filtres du module Rapports (marque, catégorie, couleur,
 * matière, pointure). Chargées une fois, tolérantes à l'échec (liste vide plutôt
 * qu'un écran cassé).
 *
 * Note : le filtre « pointure » envoie la VALEUR de la taille (t.taille), pas l'id.
 */
export default function useRefLists(enabled = true) {
  const [refs, setRefs] = useState(EMPTY);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    const get = (path) => axios.get(`${DOMAIN}/api/produit/${path}`).then((r) => r.data).catch(() => []);

    // La hauteur de talon rejoint les référentiels partagés (18/08/2026) :
    // elle sert de FILTRE sur tous les catalogues, pas seulement à la saisie.
    // Sa route rend { niveaux: [...] } là où les autres rendent un tableau nu.
    const getTalons = () => axios.get(`${DOMAIN}/api/produit/hauteur-talon/niveaux`)
      .then((r) => (r.data && r.data.niveaux) || []).catch(() => []);

    Promise.all([get('marque'), get('categorie'), get('couleur'), get('matiere'), get('tailleAll'), getTalons()])
      .then(([marques, categories, couleurs, matieres, tailles, talons]) => {
        if (cancelled) return;
        const pointures = [...new Set((tailles || [])
          .map((t) => t.taille)
          .filter((v) => v !== null && v !== undefined))]
          .sort((a, b) => Number(a) - Number(b));

        setRefs({
          marques: (marques || []).map((m) => ({ value: m.id_marque, label: m.nom })),
          categories: (categories || []).map((c) => ({ value: c.id_categorie, label: c.nom_categorie })),
          // Repliées par famille : dans un FILTRE de rapport, le compte de
          // nuances aide à choisir (« Rose (6) »).
          couleurs: optionsCouleursParFamille(couleurs || [], { avecNbNuances: true }),
          matieres: (matieres || []).map((m) => ({ value: m.id_matiere, label: m.nom_matiere })),
          pointures: pointures.map((p) => ({ value: p, label: `P${p}` })),
          // « Non renseigné » en tête : tant que le critère se remplit, c'est
          // la vue utile — elle montre le travail qui reste, pas ce qui est
          // déjà fait. Liste vide si la route ne répond pas : un filtre sans
          // option ne s'affiche pas, plutôt qu'un menu vide et muet.
          talons: (talons || []).length
            ? [{ value: 'vide', label: 'Non renseigné' },
               ...talons.map((t) => ({
                 value: t.id_hauteur_talon,
                 label: t.fourchette ? `${t.nom} (${t.fourchette})` : t.nom,
               }))]
            : [],
        });
      });

    return () => { cancelled = true; };
  }, [enabled]);

  return refs;
}
